import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/finish-line-video-analytics.jpg")